module.exports = __webpack_public_path__ + "img/2.6_About-Us_Key-Partner_2_Sydney-Uni.ebd040d09cba4be95b12b6ad8bcddb73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_About-Us_Key-Partner_2_Sydney-Uni.png
// module id = 779
// module chunks = 0